import React, { Fragment } from "react";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import Logo from "../../images/caobangceritage.svg"
// import EventSection from "../../components/EventSection/EventSection";
// import CtaSection from "../../components/CtaSection/CtaSection";
import anh1 from '../../images/assets-gallery/anh1.png'; 
import anh2 from '../../images/assets-gallery/anh2.png';
import anh3 from '../../images/assets-gallery/anh3.png';
import anh4 from '../../images/assets-gallery/anh4.png';
import anh5 from '../../images/assets-gallery/anh5.png';
import anh6 from '../../images/assets-gallery/anh6.png';
import anh7 from '../../images/assets-gallery/anh7.png';
import anh8 from '../../images/assets-gallery/anh8.png';
import anh9 from '../../images/assets-gallery/anh9.png';
import anh10 from '../../images/assets-gallery/anh10.png';
import anh11 from '../../images/assets-gallery/anh11.png';
import anh12 from '../../images/assets-gallery/anh12.png';
import anh13 from '../../images/assets-gallery/anh13.png';
import anh14 from '../../images/assets-gallery/anh14.png';
import anh15 from '../../images/assets-gallery/anh15.png';
import anh16 from '../../images/assets-gallery/anh16.png';
import anh17 from '../../images/assets-gallery/anh17.png';
import anh18 from '../../images/assets-gallery/anh18.png';
import anh19 from '../../images/assets-gallery/anh19.png';
import anh20 from '../../images/assets-gallery/anh20.png';
import anh21 from '../../images/assets-gallery/anh21.png';
import anh22 from '../../images/assets-gallery/anh22.png';
import anh23 from '../../images/assets-gallery/anh23.png';
import anh24 from '../../images/assets-gallery/anh24.png';
import anh25 from '../../images/assets-gallery/anh25.png';
import anh26 from '../../images/assets-gallery/anh26.png';
import anh27 from '../../images/assets-gallery/anh27.png';
import anh28 from '../../images/assets-gallery/anh28.png';
import anh29 from '../../images/assets-gallery/anh29.png';
import anh30 from '../../images/assets-gallery/anh30.png';
import anh31 from '../../images/assets-gallery/anh31.png';
import anh32 from '../../images/assets-gallery/anh32.png';
import anh33 from '../../images/assets-gallery/anh33.png';
import anh34 from '../../images/assets-gallery/anh34.png';
import anh35 from '../../images/assets-gallery/anh35.png';
import anh36 from '../../images/assets-gallery/anh36.png';
import anh37 from '../../images/assets-gallery/anh37.png';
import anh38 from '../../images/assets-gallery/anh38.png';
import anh39 from '../../images/assets-gallery/anh39.png';
import anh40 from '../../images/assets-gallery/anh40.png';
import anh41 from '../../images/assets-gallery/anh41.png';
import ImageGallery from "../../components/ImageGallery/ImageGallery";
import BotChatGPT from '../ChatbotPopUp';
import AiVoice from '../../components/AiVoice/AiVoice';
const galleryImages = [
  { id: 1, src: anh1, alt: 'Mô tả ảnh 1' },
  { id: 2, src: anh2, alt: 'Mô tả ảnh 2' },
  { id: 3, src: anh3, alt: 'Mô tả ảnh 3' },
  { id: 4, src: anh4, alt: 'Mô tả ảnh 4' },
  { id: 5, src: anh5, alt: 'Mô tả ảnh 5' },
  { id: 6, src: anh6, alt: 'Mô tả ảnh 6' },
  { id: 7, src: anh7, alt: 'Mô tả ảnh 7' },
  { id: 8, src: anh8, alt: 'Mô tả ảnh 8' },
  { id: 9, src: anh9, alt: 'Mô tả ảnh 9' },
  { id: 10, src: anh10, alt: 'Mô tả ảnh 10' },
  { id: 11, src: anh11, alt: 'Mô tả ảnh 11' },
  { id: 12, src: anh12, alt: 'Mô tả ảnh 12' },
  { id: 13, src: anh13, alt: 'Mô tả ảnh 13' },
  { id: 14, src: anh14, alt: 'Mô tả ảnh 14' },
  { id: 15, src: anh15, alt: 'Mô tả ảnh 15' },
  { id: 16, src: anh16, alt: 'Mô tả ảnh 16' },
  { id: 17, src: anh17, alt: 'Mô tả ảnh 17' },
  { id: 18, src: anh18, alt: 'Mô tả ảnh 18' },
  { id: 19, src: anh19, alt: 'Mô tả ảnh 19' },
  { id: 20, src: anh20, alt: 'Mô tả ảnh 20' },
  { id: 21, src: anh21, alt: 'Mô tả ảnh 21' },
  { id: 22, src: anh22, alt: 'Mô tả ảnh 22' },
  { id: 23, src: anh23, alt: 'Mô tả ảnh 23' },
  { id: 24, src: anh24, alt: 'Mô tả ảnh 24' },
  { id: 25, src: anh25, alt: 'Mô tả ảnh 25' },
  { id: 26, src: anh26, alt: 'Mô tả ảnh 26' },
  { id: 27, src: anh27, alt: 'Mô tả ảnh 27' },
  { id: 28, src: anh28, alt: 'Mô tả ảnh 28' },
  { id: 29, src: anh29, alt: 'Mô tả ảnh 29' },
  { id: 30, src: anh30, alt: 'Mô tả ảnh 30' },
  { id: 31, src: anh31, alt: 'Mô tả ảnh 31' },
  { id: 32, src: anh32, alt: 'Mô tả ảnh 32' },
  { id: 33, src: anh33, alt: 'Mô tả ảnh 33' },
  { id: 34, src: anh34, alt: 'Mô tả ảnh 34' },
  { id: 35, src: anh35, alt: 'Mô tả ảnh 35' },
  { id: 36, src: anh36, alt: 'Mô tả ảnh 36' },
  { id: 37, src: anh37, alt: 'Mô tả ảnh 37' },
  { id: 38, src: anh38, alt: 'Mô tả ảnh 38' },
  { id: 39, src: anh39, alt: 'Mô tả ảnh 39' },
  { id: 40, src: anh40, alt: 'Mô tả ảnh 40' },
  { id: 41, src: anh41, alt: 'Mô tả ảnh 41' }
];

const GalleryPage = () => {
  return (
    <Fragment>
      <Navbar Logo={Logo} />
      <PageTitle pageTitle={"Thư viện ảnh"} pagesub={"Thư viện ảnh"} />
      {/* <EventSection />
      <CtaSection /> */}
      <ImageGallery images={galleryImages} />
      <Footer />
      <AiVoice />
      <BotChatGPT />
    </Fragment>
  );
};

export default GalleryPage;
